import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IUserAccountBalance } from '../models/user-account-balance.model';

const API_USER_ACCOUNT_BALANCE_URL = `${environment.apiUrl}/users/account_balance`;

@Injectable({ providedIn: 'root' })
export class UserAccountBalanceService {
  private readonly _http = inject(HttpClient);

  get(pilotId: number, businessId?: number): Observable<IUserAccountBalance> {
    return this._http.get<IUserAccountBalance>(
      `${API_USER_ACCOUNT_BALANCE_URL}/${pilotId}?businessId=${businessId ?? ''}`
    );
  }

  getAll(pilotId: number): Observable<IUserAccountBalance[]> {
    return this._http.get<IUserAccountBalance[]>(`${API_USER_ACCOUNT_BALANCE_URL}/${pilotId}/all`);
  }
}
